import type {
  Item,
  ItemAttachment,
  ItemReminder,
} from "~/api/generated/types.gen";

type AttachmentKind = ItemAttachment["kind"];
type ItemCategory = Item["category"];
type ItemStatus = Item["status"];
type ReminderKind = ItemReminder["kind"];

export const CATEGORY_OPTIONS: { value: ItemCategory; label: string }[] = [
  { value: "tool", label: "Hand tool" },
  { value: "power_tool", label: "Power tool" },
  { value: "device", label: "Device" },
  { value: "camera", label: "Camera" },
  { value: "computer", label: "Computer" },
  { value: "audio", label: "Audio" },
  { value: "vehicle", label: "Vehicle" },
  { value: "safety", label: "Safety" },
  { value: "other", label: "Other" },
];

export const STATUS_OPTIONS: { value: ItemStatus; label: string }[] = [
  { value: "in_use", label: "In use" },
  { value: "stored", label: "Stored" },
  { value: "loaned", label: "Loaned out" },
  { value: "retired", label: "Retired" },
  { value: "lost", label: "Lost" },
];

export const ATTACHMENT_KIND_LABELS: Record<AttachmentKind, string> = {
  photo: "Photo",
  receipt: "Receipt",
  manual: "Manual",
  other: "Other",
};

export const REMINDER_KIND_LABELS: Record<ReminderKind, string> = {
  warranty: "Warranty",
  service: "Service",
};

export const KIT_COLORS = [
  "#3D5A80",
  "#E8A838",
  "#1C2321",
  "#6B4F3A",
  "#5C7A5A",
  "#8C4A3A",
];

export function categoryLabel(value: ItemCategory) {
  return (
    CATEGORY_OPTIONS.find((option) => option.value === value)?.label ?? value
  );
}

export function statusLabel(value: ItemStatus) {
  return (
    STATUS_OPTIONS.find((option) => option.value === value)?.label ?? value
  );
}
